import { useEffect, useState } from "react";
import { useT } from "../i18n";
import Header from "./Header";
import { Link } from "react-router-dom";
import Footer from "./Footer";

function About(props) {
    const t = useT();
  const [modalState, setModalState] = useState(false);
  useEffect(() => {
    props.checkLogin();
  }, []);
  return (
    <div id="Company">
      <Header userInfo={props.userInfo} logout={props.logout} />
      <main>
        <div className="container">
          <h2 className="mobile_title">PROP.MATE</h2>
          <div className="image_container">
            <img src={process.env.PUBLIC_URL + 'images/company/company.png'} alt={t("건축물사진")} />
          </div>
          <div className="information_container">
            <div className="text_wrap">
              <h2>PROP.MATE</h2>
              <p> 
                <span>
                  {t('프롭메이트는 지도 기반으로')} <br />
                  {t('토지 관련 모든 정보를 신속하고 정확하게 제공하는 전문 서비스를 자랑합니다.')}
                </span>
                <span>
                  {t('강력한 데이터베이스와 AI 기술을 바탕으로,')}<br />
                  {t('고객이 원하는 건물을 지을 수 있는 규모와 예상 비용을 정밀하게 예측합니다.')}<br />
                  {t('또한, 건축 가능 용도에 따른 다양한 개발 옵션을 제시하며,')}<br />
                  {t('끊임없이 발전하는 기술과 정보를 통해 고객이 가장 현명한 결정을 내릴 수 있도록 지원합니다.')}
                </span>
                <span>
                  {t('항상 고객 만족을 최우선 가치로 삼으며,')}<br />
                  {t('함께하는 모든 건축 과정에서 안도감과 신뢰를 제공하는 든든한 파트너가 되겠습니다.')}
                </span>
                <span>
                  {t('프롭메이트와 함께라면,')}<br />
                  {t('혁신적인 기술과 신뢰할 수 있는 전문성을 통해 고객의 꿈을 현실로 만들어 드립니다.')}
                </span>
              </p>
            </div>
            <div className="info-bottom">
              <div className="download">
                <p>
                  <span>Download</span>
                </p>
                <ul className="file_wrap">
                  <li>
                    <div className="file_img">
                      <img src={process.env.PUBLIC_URL + 'images/company/about-company-ko-color.png'} alt={t("IR파일이미지")} />
                    </div>
                    <a href="https://drive.google.com/file/d/10h9p4S8uyTuLN9HyPhJuXPpbrl_eT7XA/view?usp=drive_link" target="_blank" className="file_opacity">
                      <h3>{t('기업소개서')}</h3>
                      <p>{t('한국어')}</p>
                    </a>
                  </li>
                  <li>
                    <div className="file_img">
                      <img src={process.env.PUBLIC_URL + 'images/company/about-company-en-color.png'} alt={t("회사소개파일이미지")} />
                    </div>
                    <a href="https://drive.google.com/file/d/1tuWSchZ_wylENrAasQe33jfAEZgOsWHE/view?usp=drive_link" target="_blank" className="file_opacity">
                      <h3>Introduction</h3>
                      <p>English</p>
                    </a>
                  </li>
                  {/* <li>
                    <div className="file_img">
                      <img src={process.env.PUBLIC_URL + 'images/company/file3.png'} alt="포트폴리오 파일이미지" />
                    </div>
                    <a href="https://drive.google.com/file/d/1KIcH4_jOcSEk5EULrWRw0xlsKhErf1Jk/view?usp=drive_link" target="_blank" className="file_opacity">
                      <h3>français</h3>
                      <p>la présentation de l'entreprise</p>
                    </a>
                  </li> */}
                </ul>
              </div>
              <div className="sns-wrap">
                <div className="insta-box">
                 <a href="#">
                    <span>Instagram</span>
                    <img src={process.env.PUBLIC_URL + 'images/company/about-insta-img.png'} alt="insta" />
                 </a>
                </div>
                <div className="youtube-box">
                  <a href="https://www.youtube.com/@Propmate_inc" target="_blank" >
                    <span>youtube</span>
                    <img src={process.env.PUBLIC_URL + 'images/company/about-youtube-img.png'} alt="youtube" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main >
      <div></div>

      {
        modalState &&

        <div className="modal">
          <div className="modal_content">
            <div className="title">{t('회사소개서 언어 선택')}</div>
            <div className="btn_wrap">
              <a className="korea">{t('한국어 🇰🇷')}</a>
              <a className="english">English 🇺🇸</a>
            </div>
            <div className="close_btn" onClick={() => { setModalState(false); }}></div>
          </div>
        </div>

      }
    </div >
  );
}

export default About;